<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6 0C5.44772 0 5 0.447715 5 1C5 1.55228 5.44772 2 6 2H10C10.5523 2 11 1.55228 11 1C11 0.447715 10.5523 0 10 0H6ZM4 1H2C1.44772 1 1 1.44772 1 2V15C1 15.5523 1.44772 16 2 16H14C14.5523 16 15 15.5523 15 15V2C15 1.44772 14.5523 1 14 1H12V2C12 2.55228 11.5523 3 11 3H5C4.44772 3 4 2.55228 4 2V1ZM11.0303 6.96967C11.3232 7.26256 11.3232 7.73744 11.0303 8.03033L7.53033 11.5303C7.23744 11.8232 6.76256 11.8232 6.46967 11.5303L4.96967 10.0303C4.67678 9.73744 4.67678 9.26256 4.96967 8.96967C5.26256 8.67678 5.73744 8.67678 6.03033 8.96967L7 9.93934L9.96967 6.96967C10.2626 6.67678 10.7374 6.67678 11.0303 6.96967Z"
    />
  </svg>
</template>
